// extracted by mini-css-extract-plugin
export var fadeIn = "_k2-1";
export var modalContent = "_k2-3";
export var overlay = "_k2-0";
export var popoverContent = "_k2-2";
export var results = "_k2-5";
export var searchInputWrapper = "_k2-4";